import {Container, Divider, Grid, GridColumn, Image, List, Segment} from "semantic-ui-react";
import React from 'react'
import {config} from "config.js";
import './footer.css'
import elixirLogo from '../../static/images/elixir_luxembourg_logo.svg'

export default function Footer(props) {
    return (<Segment id='footer' inverted vertical>
        <Container textAlign='center'>
            {/*<Image src='/logo.png' centered size='mini'/>*/}
            <List horizontal inverted divided link size='small'>
                <List.Item as='a' href='https://elixir-luxembourg.org/contact'>
                    Contact Us
                </List.Item>
                <List.Item as='a' href='https://elixir-luxembourg.org/privacy/terms_of_use'>
                    Terms and Conditions
                </List.Item>
                <List.Item as='a' href='https://elixir-luxembourg.org/privacy/'>
                    Privacy Policy
                </List.Item>
            </List>
            {config.EXTRA_FOOTER && <div dangerouslySetInnerHTML={{__html: config.EXTRA_FOOTER}}></div>}
            <Grid centered columns={1}>
                <GridColumn width={2}>
                    <Divider inverted section/>
                </GridColumn>
            </Grid>
            <a style={{textAlign: 'center', color: 'white'}}
               href="https://elixir-luxembourg.org/">
                Provided by ELIXIR-LU</a>
            <br/>
            <a style={{textAlign: 'center', color: 'white'}}
               href="https://elixir-luxembourg.org/"><Image style={{display: 'inline-block'}} size={'small'}
                                                            alt='elixir luxembourg'
                                                            src={elixirLogo}/></a>

        </Container>
    </Segment>)

}